import axiosInstance from '../lib/axios';

export const fetchIndustries = async ({ queryKey }) => {
    const [_key, { industriesType, filteredData }] = queryKey;
    const response = await axiosInstance.get('/admin/industries', {
        params: { industriesType: industriesType, filteredData: filteredData }
    });
    return response.data;
};
export const updateIndustry = async (id, industryData) => {
    try {
        const response = await axiosInstance.put(`/admin/updateIndustry/${id}`, industryData);

        return response.data; // Return the update industry
    } catch (error) {
        console.error('Error update Industry:', error);
        throw error;
    }
};
export const addIndustry = async (industryData) => {
    try {
        const response = await axiosInstance.post('/admin/addIndustry', industryData);

        return response.data; // Return the created industry
    } catch (error) {
        console.error('Error adding Industry:', error);
        throw error; 
    }
};
export const fetchAllIndustriesList = async ({ queryKey }) => {
    const response = await axiosInstance.get('/admin/allIndustriesAllIndustriesList');
    return response.data;
};
// Function to delete Industry
export const deleteIndustry = (id) => axiosInstance.delete(`/admin/Industry/${id}`);
